class CheckoutError extends Error {
    /**
     * @param {string} checkoutStage
     * @param {string} message
     * @param {Error} [cause]
     */
    constructor(
        checkoutStage,
        message,
        cause = null,
    ) {
        super(message, { cause });

        /**
         * @type {string}
         */
        this.checkoutStage = checkoutStage;

        /**
         * Did this error occur late enough in the checkout process that we should clear the cart?
         *
         * @type {boolean}
         */
        this.clearCart = false;

        /**
         * @type {boolean}
         */
        this.clearPayments = false;

        /**
         * Should this error result in a redirect to the failure destination?
         *
         * @type {boolean}
         */
        this.redirectForFailure = false;
    }

    /**
     * @returns {CheckoutError}
     */
    shouldClearCart() {
        this.clearCart = true;

        return this;
    }

    /**
     * @returns {CheckoutError}
     */
    shouldClearPayments() {
        this.clearPayments = true;

        return this;
    }

    /**
     * @returns {CheckoutError}
     */
    shouldRedirectForFailure() {
        this.redirectForFailure = true;

        return this;
    }

    /**
     * @returns {string}
     */
    get userFacingTitleLangKey() {
        return `CHECKOUT_ERROR_TITLES.${this.checkoutStage}`;
    }
}

module.exports = CheckoutError;
